module.exports = __webpack_public_path__ + "static/media/20_A.ecc96545.png";